export default __webpack_public_path__ + "static/Logo-white-91c98ef05eac95e67e47be3308583155.png";